import TagManager from 'react-gtm-module';

const init = ({ gtmId, auth, preview, dataLayerName }) => {
  console.log('Initializing Google Tag Manager with ID:', gtmId);
  TagManager.initialize({
    gtmId,
    auth,
    preview,
    dataLayerName,
  });
};

const setDataLayer = (dataLayerName, pathname) => {
  console.log('Setting Google Tag Manager data layer for page:', pathname);
  TagManager.dataLayer({
    dataLayer: {
      page: pathname,
    },
    dataLayerName,
  });
};

export default { init, setDataLayer };
